module.exports = __webpack_public_path__ + "static/img/logo.c7d1958.png";


//////////////////
// WEBPACK FOOTER
// ./resources/holataxi/img/logo.png
// module id = jW0x
// module chunks = 1